import React, { useEffect, useRef, useState } from 'react'
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import moment from "moment";
import '../../../common/rsuite-datepicker.css'
import Select from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import { getAccountWebHookSenderLogAsync, resetSelectedRecordObjectInState
,setDateRangeValue,setOptionStatusValue,setOptionWebHookEventTypeValue
} from "./WebHookSenderLogSlice";
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { dropDownSelectionStyles, getValueFromResource, normalizeDateFormat } from '../../../common/timeLiveFunction';
import { format } from 'date-fns';
import DatePickerRanges from '../../../common/DatePickerRanges';


const WebHookSenderLogOffCanvas = (props: any) => {

   const {webhooksenderlogid,t} = props;
   const { maxMenuHeight,CurrentCultureDateFormat} = useAppSelector((state) => state.globalState);

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());

    const [statusArray, SetstatusArray] = useState<any | ''>([]);
    const [selectedOptionDropDown, setSelectedOptionDropDown] = useState<{ [object: string]: any }>({ value: 'All', label: 'All' });

    const [WebhookEventArray, SetWebhookEventArray] = useState<any | ''>([]);
    const [selectedWebhookEventOptionDropDown, setSelectedWebhookEventOptionDropDown] = useState<{ [object: string]: any }>({ value: 'All', label: 'All' });
    const { pageSize,pageNo,sortColumn,sortOrder,startRec, search } = useAppSelector((state) => state.webHookSenderLog);
    const dispatch = useAppDispatch();

    useEffect(() => {
        let Status = [
            { value: 'All', label: 'All' },
            { value: 'success', label: 'Success' },
            //{ value: 'in progress', label: 'In Progress' },
            { value: 'fail', label: 'Fail' }
        ]
        SetstatusArray(Status);
    }, [])

    const getWebhookEventAsync = async () => {
        const response = await fetchAPI("api/V2/Logs/WebhookEventTypeCaptionsForSenderDropDown/", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();

        json.Data.items.map((item: any) => {
            item.value = item.id;
            item.label = item.text;
            delete item.id;
            delete item.text;
        });
        json.Data.items.unshift({ value: 'All', label: 'All' })

        SetWebhookEventArray(json.Data.items);
    }

    useEffect(() => {
        getWebhookEventAsync();
    }, [])

    const handleDateRangeChange = (value: any) => {
        setStartDate(value[0]);
        setEndDate(value[1]);
        // dispatch(setDateRangeValue({startDate:value[0].toISOString(),endDate:value[1].toISOString()}));
        dispatch(setDateRangeValue({startDate: format(value[0], "yyyy-MM-dd"), endDate: format(value[1], "yyyy-MM-dd")}));
    };

    const handleChange = (data: any) => {
        const { value, label } = data;
        setSelectedOptionDropDown({ value: value, label: label });
        dispatch(setOptionStatusValue({ value: value, label: label }));
    };

    const handleWebhookEventChange = (data: any) => {
        const { value, label } = data;
        setSelectedWebhookEventOptionDropDown({ value: value, label: label });
        dispatch(setOptionWebHookEventTypeValue({ value: value, label: label }));
    };

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    const handleApplyFilterOnClickEvent = () => {
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
        dispatch(resetSelectedRecordObjectInState());
        let SearchParamsValues = `${selectedOptionDropDown.value},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')},${selectedWebhookEventOptionDropDown.value}`;
        dispatch(getAccountWebHookSenderLogAsync());
    };

    const handleResetFiltersOnClickEvent = () => {
        setStartDate(new Date());
        setEndDate(new Date());
        setSelectedOptionDropDown({ value: 'All', label: 'All' });
        setSelectedWebhookEventOptionDropDown({ value: 'All', label: 'All' });
        dispatch(resetSelectedRecordObjectInState());

        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    };
    
   
    return (
        <>
            <div className='card-body'>
                <div className='row' >
                <div className="col-md-12">
                <label className="form-label fs-7 fw-normal mb-2">
                    {/* {t('Date Range')} */}
                    {getValueFromResource('Date Range',dispatch, t)}
                    </label>
                        <div>
                            <DateRangePicker
                                onChange={handleDateRangeChange}
                                ranges={DatePickerRanges() }
                                value={[startDate, endDate]}
                                placeholder='Please Select Date Range'
                                cleanable={false}
                                placement="bottomEnd"
                                format={normalizeDateFormat(CurrentCultureDateFormat.toString())}
                            ></DateRangePicker>
                        </div>
                    </div>
                    <div className='col-md-12 mt-6'>
                    <label className="form-label fs-7 fw-normal mb-2">
                        {/* {t('Status')} */}
                        {getValueFromResource('Status',dispatch, t)}
                        </label>
                        <div>
                            <Select
                                value={selectedOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleChange}
                                options={statusArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                        </div>
                    </div>
                </div>
                <div className='row' >
                <div className='col-md-12 mt-6'>
                <label className="form-label fs-7 fw-normal mb-2">
                    {/* {t('Webhook Event Type')} */}
                    {getValueFromResource('Webhook Event Type',dispatch, t)}

                    </label>
                        <div>
                            <Select
                                value={selectedWebhookEventOptionDropDown}
                                className="basic-single"
                                classNamePrefix="select"
                                isSearchable={true}
                                name="StatusList"
                                onChange={handleWebhookEventChange}
                                options={WebhookEventArray}
                                styles={dropDownSelectionStyles}
                                maxMenuHeight={maxMenuHeight}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    <div className='d-flex align-items-center me-2'>
                        <button
                            type='button'
                            ref={closeButtonRef}
                            style={{ display: 'none' }}
                            id='kt_OffCanvas_close'
                        >
                        </button>
                        <button
                            className="btn btn-secondary btn-sm me-2 fs-7"
                            type='button'
                            data-kt-element='send'
                            onClick={handleResetFiltersOnClickEvent}
                        >
                            {/* {t('Reset Filters')} */}
                            {getValueFromResource('Reset Filters',dispatch, t)}

                        </button>
                        <button
                            className="btn btn-primary btn-sm fs-7"

                            type='button'
                            data-kt-element='send'
                            onClick={handleApplyFilterOnClickEvent}
                        >
                            {/* {t('Apply Filters')} */}
                            {getValueFromResource('Apply Filters',dispatch, t)}

                        </button>
                    </div>
                </div>
            </div>

        </>

    )

}




export default WebHookSenderLogOffCanvas